/**
 * Utility to convert numbers into Indian Currency Words format
 * e.g., 45250 -> "Rupees Forty Five Thousand Two Hundred Fifty Only"
 * 125000.50 -> "Rupees One Lakh Twenty Five Thousand and Fifty Paise Only"
 */

const ones = [
  "",
  "One",
  "Two",
  "Three",
  "Four",
  "Five",
  "Six",
  "Seven",
  "Eight",
  "Nine",
  "Ten",
  "Eleven",
  "Twelve",
  "Thirteen",
  "Fourteen",
  "Fifteen",
  "Sixteen",
  "Seventeen",
  "Eighteen",
  "Nineteen",
];

const tens = [
  "",
  "",
  "Twenty",
  "Thirty",
  "Forty",
  "Fifty",
  "Sixty",
  "Seventy",
  "Eighty",
  "Ninety",
];

function convertLessThanThousand(num: number): string {
  if (num === 0) return "";

  let result = "";

  if (num >= 100) {
    result += ones[Math.floor(num / 100)] + " Hundred ";
    num %= 100;
  }

  if (num > 0) {
    if (num < 20) {
      result += ones[num];
    } else {
      result += tens[Math.floor(num / 10)] + (num % 10 !== 0 ? " " + ones[num % 10] : "");
    }
  }

  return result.trim();
}

export function numberToIndianWords(amount: number): string {
  if (isNaN(amount) || amount === null || amount === undefined) {
    return "Rupees Zero Only";
  }

  const isNegative = amount < 0;
  const absAmount = Math.abs(amount);

  const wholePart = Math.floor(absAmount);
  const decimalPart = Math.round((absAmount - wholePart) * 100);

  if (wholePart === 0 && decimalPart === 0) {
    return "Rupees Zero Only";
  }

  let words = "";

  const crore = Math.floor(wholePart / 10000000);
  const remainderAfterCrore = wholePart % 10000000;

  const lakh = Math.floor(remainderAfterCrore / 100000);
  const remainderAfterLakh = remainderAfterCrore % 100000;

  const thousand = Math.floor(remainderAfterLakh / 1000);
  const remainderAfterThousand = remainderAfterLakh % 1000;

  const remainder = remainderAfterThousand;

  if (crore > 0) {
    words += convertLessThanThousand(crore) + " Crore ";
  }

  if (lakh > 0) {
    words += convertLessThanThousand(lakh) + " Lakh ";
  }

  if (thousand > 0) {
    words += convertLessThanThousand(thousand) + " Thousand ";
  }

  if (remainder > 0) {
    words += convertLessThanThousand(remainder);
  }

  words = words.trim();

  let finalString = "Rupees " + (words || "Zero");

  if (decimalPart > 0) {
    finalString += " and " + convertLessThanThousand(decimalPart) + " Paise";
  }

  finalString += " Only";

  return isNegative ? "Minus " + finalString : finalString;
}

export function formatINR(amount: number): string {
  if (isNaN(amount) || amount === null || amount === undefined) {
    return "₹0.00";
  }
  return new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(amount);
}
